

<div class="" style="padding:15px;background:#fff;">
  <div class="control-section">
    <div class="control-wrapper">
      <div class="default-section">
        <div class='forum'>
          <div class="questionSection">

            <div class="raiser">
              <table>
                <tbody>
                  <tr>
                    <td rowspan="2">
                      <div class="questionar">
                        <img style="border-radius: 50%" width="35" height="35" align="left" src="/Import/ShowImage_AnhCanBo/{{baivietSelect.NhanSuId}}" *ngIf="baivietSelect.CoAnh!='0'">
                        <img width="35" height="35" align="left" src="/assets/img/default.png" *ngIf="baivietSelect.CoAnh=='0'">
                      </div>
                    </td>
                    <td>
                      <div class="header">
                        {{baivietSelect.TieuDe}}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="Questionarname">
                        <em class="mr-2 far fa-user-circle"></em>{{baivietSelect.CreatedBy}}
                        <em class="icon-clock mr-2" style="margin-left:20px;"></em>{{baivietSelect.Created | date:'dd/MM/yyyy HH:mm'}}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="questionHeader">
              <div class="explain">
                <span [innerHtml]="baivietSelect.NoiDung"></span>
              </div>
              <div class="tags">
                <div class="full-tags">
                  <div class="tagSection">
                    <table>
                      <tbody>
                        <tr>
                          <td *ngFor='let row of baivietSelect.TuKhoas; let i = index'>
                            <div class="tag"> {{row.Value}} </div>
                          </td>

                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="questionLikes">
                    <table>
                      <tbody>
                        <tr>
                          <td>
                            <span class="e-icon e-like questionSide" (click)="likedispost(baivietSelect,1)">
                              <em class="icon-like mr-2" [ngClass]="{'liked': baivietSelect.DaLike === 1}"></em>
                              <span>{{baivietSelect.LuotLike}} Like</span>
                            </span>
                          </td>
                          <td>
                            <span class="e-icon e-dislike" (click)="likedispost(baivietSelect,0)">
                              <em class="icon-dislike mr-2" [ngClass]="{'liked': baivietSelect.DaDislike === 1}"></em>
                              <span> {{baivietSelect.LuotDislike}} Dislike</span>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="reply-tags">
                  <a class="e-icon e-dislike" (click)="reply(baivietSelect,1)">
                    <!--<em class="mr-2 fas fa-reply"></em>-->
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                         viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g><g>
                    <path d="M234.667,170.844V96c0-17.646-14.354-32-32-32c-7.938,0-15.604,3.042-21.542,8.563l-13.771,12.74
			C122.042,127.229,46.188,197.396,7.375,236.323C2.625,241.115,0,248.094,0,256s2.625,14.885,7.375,19.688
			c38.813,38.917,114.667,109.083,159.979,151.01l13.771,12.74c5.938,5.521,13.604,8.563,21.542,8.563c17.646,0,32-14.354,32-32
			v-74.594c153.604,2.156,256,50.604,256,95.927c0,5.896,4.771,10.667,10.667,10.667c5.896,0,10.667-4.771,10.667-10.667
			C512,293.594,388.563,176.052,234.667,170.844z M224,320c-5.896,0-10.667,4.771-10.667,10.667V416
			c0,5.885-4.792,10.667-10.667,10.667c-3.25,0-5.625-1.563-7.042-2.875l-13.771-12.75C136.646,369.219,61,299.24,22.5,260.635
			c-0.583-0.583-1.167-2.25-1.167-4.635s0.583-4.052,1.167-4.625C61,212.76,136.646,142.781,181.854,100.958l13.771-12.75
			c1.417-1.313,3.792-2.875,7.042-2.875c5.875,0,10.667,4.781,10.667,10.667v85.333c0,5.896,4.771,10.667,10.667,10.667
			c128.25,0,235.646,83.729,261,194.885C439.479,347.01,340.917,320,224,320z" />































	</g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
                    {{'Trả lời' | translate}}
                  </a>
                  <a (click)="deleterow(baivietSelect,1);" *ngIf="(username==baivietSelect.CreatedBy || quyen_xoa==true)">
                    <em class="ml-2 fas fa-times"></em>
                    {{'Xóa' | translate}}
                  </a>
                </div>
              </div>
            </div>
            <div class="separator"></div>
          </div>
          <div class="answerSection">
            <div class="answerCount">{{baivietSelect.LuotBinhLuan}} {{'bài trả lời' | translate}}</div>
            <ng-container *ngFor='let data of baivietSelect.TraLois; let i = index'>
              <div class="answer">
                <table>
                  <tbody>
                    <tr>
                      <td rowspan="2">
                        <img style="border-radius: 50%" width="35" height="35" align="left" src="/Import/ShowImage_AnhCanBo/{{data.NhanSuId}}" *ngIf="data.CoAnh!='0'">
                        <img width="35" height="35" align="left" src="/assets/img/default.png" *ngIf="data.CoAnh=='0'">
                      </td>
                      <td>
                        <div class="authorname">{{data.CreatedBy}}</div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="detailsAnswer">{{'Trả lời lúc' | translate}}: {{data.Created | date:'dd/MM/yyyy HH:mm'}}</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="posting" [innerHtml]="data.NoiDung">

                </div>
                <div class="likeAnswer">
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <span class="e-icon e-like" (click)="likedispost(data,1)">
                            <em class="icon-like mr-2" [ngClass]="{'liked': data.DaLike === 1}"></em>
                            <span>{{data.LuotLike}} Like</span>
                          </span>
                        </td>
                        <td>
                          <span class="e-icon e-dislike"  (click)="likedispost(data,0)">
                            <em class="icon-dislike mr-2" [ngClass]="{'liked': data.DaDislike === 1}"></em>
                            <span>{{data.LuotDislike}} Dislike</span>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="reply-tags">
                 
                    <a class="e-icon e-dislike" (click)="reply(data,2)">
                      <!--<em class="mr-2 fas fa-reply"></em>-->
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                           viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g><g>
                      <path d="M234.667,170.844V96c0-17.646-14.354-32-32-32c-7.938,0-15.604,3.042-21.542,8.563l-13.771,12.74
			C122.042,127.229,46.188,197.396,7.375,236.323C2.625,241.115,0,248.094,0,256s2.625,14.885,7.375,19.688
			c38.813,38.917,114.667,109.083,159.979,151.01l13.771,12.74c5.938,5.521,13.604,8.563,21.542,8.563c17.646,0,32-14.354,32-32
			v-74.594c153.604,2.156,256,50.604,256,95.927c0,5.896,4.771,10.667,10.667,10.667c5.896,0,10.667-4.771,10.667-10.667
			C512,293.594,388.563,176.052,234.667,170.844z M224,320c-5.896,0-10.667,4.771-10.667,10.667V416
			c0,5.885-4.792,10.667-10.667,10.667c-3.25,0-5.625-1.563-7.042-2.875l-13.771-12.75C136.646,369.219,61,299.24,22.5,260.635
			c-0.583-0.583-1.167-2.25-1.167-4.635s0.583-4.052,1.167-4.625C61,212.76,136.646,142.781,181.854,100.958l13.771-12.75
			c1.417-1.313,3.792-2.875,7.042-2.875c5.875,0,10.667,4.781,10.667,10.667v85.333c0,5.896,4.771,10.667,10.667,10.667
			c128.25,0,235.646,83.729,261,194.885C439.479,347.01,340.917,320,224,320z" />



	</g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
                      {{'Trả lời' | translate}}
                    </a>
                    <a (click)="deleterow(data,2);" *ngIf="(username==data.CreatedBy || quyen_xoa==true)">
                      <em class="ml-2 fas fa-times"></em>
                      {{'Xóa' | translate}}
                    </a>
                  </div>
                </div>
                <div class="separator"></div>
              </div>
            </ng-container>
          </div>

          <div id="createpostholder" >
            <div class="clearfix" novalidate="novalidate">
              <ejs-richtexteditor [height]='340' #toolsRTE id='alltoolRTE' [(value)]='postSelect.NoiDung'
                                  [insertImageSettings]='insertImageSettings'
                                   [fileManagerSettings]='fileManagerSettings'
                                  (actionComplete)='actionCompleteHandler($event)'
                                  >
              </ejs-richtexteditor>
              <div id='buttonSection'>
                <table>
                  <tr>
                    <td>
                      <button ejs-button #rteCancel (click)="cancelClick()" id="rteCancel">{{'Hủy bỏ' | translate}}</button>
                    </td>
                    <td>
                      <button ejs-button [isPrimary]="true" (click)="submitClick()" #rteSubmit id="rteSubmit">{{'Trả lời' | translate}}</button>

                    </td>

                  </tr>
                </table>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

